/**
 * Markup zu Klartext — für Zwischenablage und Mail-Entwurf.
 *
 * Wird gebraucht, sobald eine von Hand bearbeitete Fassung des Statusberichts
 * vorliegt: Der Entwurf muss dann aus **dieser** Fassung entstehen und nicht
 * aus den Rohdaten, sonst geht die Bearbeitung auf dem Weg zum Kunden verloren
 * (Befund G10, dritte Wirkung).
 *
 * Bewusst ohne DOM: Die Funktion soll ohne Browser prüfbar sein. Sie ist eine
 * Reduktion für die Anzeige, **keine** Sicherheitsmaßnahme — die
 * Markup-Säuberung passiert an der Ausgabe über DOMPurify.
 */

/** Elemente, deren Ende eine Zeile beendet. */
const BLOCK_END =
  /<\/(p|div|tr|li|h[1-6]|table|section|header|footer|blockquote)\s*>/gi;

export function htmlToPlainText(html: string): string {
  return (
    html
      // Inhalte, die nie sichtbar sind, komplett entfernen — sonst stünde
      // CSS oder Skriptquelltext im Mailentwurf.
      .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(BLOCK_END, "\n")
      .replace(/<[^>]*>/g, "")
      // Entities, die in diesem Bericht tatsächlich vorkommen.
      .replace(/&nbsp;/gi, " ")
      .replace(/&#(\d+);/g, (_, code: string) => String.fromCharCode(Number(code)))
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, '"')
      .replace(/&#0?39;|&apos;/gi, "'")
      // `&amp;` zuletzt, sonst entstünde aus `&amp;lt;` ein `<`.
      .replace(/&amp;/gi, "&")
      // Leerraum je Zeile zusammenziehen, Leerzeilen auf höchstens eine.
      .split("\n")
      .map((line) => line.replace(/[ \t\u00a0]+/g, " ").trim())
      .join("\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim()
  );
}
